/* Nest Box sizing calculator - behaviour.
   Pure DOM, no dependencies. Reads its numbers and copy from data-
   attributes on .nbx-calc so the section keeps them as theme settings. */
(function () {
  var SEG_PITCH = 1109, FIXED = 575, SEG_AREA = 1;

  /* Longest run we publish an assembled length for (table covers 2..6 segments).
     Anything above this is delivered as more than one system. */
  var MAX_PER_RUN = 6;

  /* Not a modelling limit — the maths is linear. Purely a guard so a typo
     cannot ask for a diagram of hundreds of runs. */
  var MAX_HENS = 10000;

  /* Above this many segments the fixed lead time stops being a claim we can
     stand behind, so the page hands off to a conversation. Becomes a theme
     setting (handoff_segments) in the section. */
  var HANDOFF_SEGMENTS = 18;

  /* Copy lives here as whole sentences with {placeholders} rather than being
     concatenated at the call site, so each string stays editable and
     translatable. These become theme settings in the section. */
  var COPY = {
    handoffTitle: 'Above {threshold} segments we plan the build with you',
    handoffBody: 'That is {segments} segments across {systems} {systemWord}, one run per coop. ' +
      'An order this size can take longer to build than our usual ~6 weeks, so we confirm a date ' +
      'with you rather than quoting one up front. Send your flock size and coop dimensions and ' +
      'we will come back with a lead time.'
  };

  function fill(tpl, vars) {
    var out = tpl;
    for (var key in vars) {
      if (Object.prototype.hasOwnProperty.call(vars, key)) {
        out = out.split('{' + key + '}').join(vars[key]);
      }
    }
    return out;
  }

  /* English fallbacks. The live copy comes from the section's
     data-el='i18n' block (locale keys gtt.nest_box_calc.*), so these only
     show if that block is missing. */
  var STR = {
    segment_one: 'segment', segment_other: 'segments',
    system_one: 'system', system_other: 'systems',
    segment_size_note: '120 cm each',
    coop_too_short: 'coop too short',
    runs_split: '{runs} segments',
    one_run_of: 'one run of {count}',
    area_need: 'need {value}',
    length_per_system: 'per system, longest run',
    hens_per_m2: 'hens/m²',
    density_max: 'max {value}',
    capacity_value: '{count} hens',
    capacity_spare: '+{count} spare',
    scale_multi: '{systems} {systemWord} · longest run {length} mm',
    scale_single: '{length} mm assembled',
    too_short_title: 'Your coop is too short for even one segment',
    too_short_body: 'A single segment needs {needed} mm end to end, and you have {available} mm.',
    recommend_title: 'We recommend {segments} {segmentWord} — one spare per system',
    recommend_body: 'At {hens} hens the minimum leaves only {spare} hens of spare nest space, under half a segment. ' +
      'From our clients’ experience that is where hens start laying on the floor: crowded nests are one of the main ' +
      'causes of eggs on the ground, and those are dirtier, crack more often, and cost you time to collect.',
    recommend_more_systems: 'A run caps at {perRun} segments, so the spare ones take this to {systems} systems ({runs}).',
    recommend_same_systems: 'That is {runs} across {systems} {systemWord}, covering up to {capacity} hens.',
    split_title: 'This needs {systems} systems, split {runs}',
    split_body_coop: 'Your {coop} mm holds {perRun} {segmentWord} per run, so the nest area is spread across ' +
      '{systems} runs — one per coop. The longest is {length} mm.',
    split_body_cap: 'A single run is limited to {max} segments by our published lengths, so the nest area is ' +
      'spread across {systems} runs — one per coop. The longest is {length} mm.',
    fits_title: 'Fits your coop, {spare} mm to spare',
    fits_body: 'Your {coop} mm takes up to {perRun} {segmentWord} — room for {capacity} hens in one run at this standard.',
    diagram_row: 'System {number}',
    diagram_aria_single: '1 system of {segments} segments at {length} millimetres, drawn to scale',
    diagram_aria_multi: '{systems} systems, the longest of {segments} segments at {length} millimetres, drawn to scale',
    diagram_coop_limit: 'coop limit {length} mm',
    diagram_more: 'and {count} more {systemWord}, same layout'
  };

  /* Liquid's t filter HTML-escapes its output; turn &#39; etc. back into text. */
  function decode(s) {
    var ta = document.createElement('textarea');
    ta.innerHTML = s;
    return ta.value;
  }

  function grp(n) { return n.toLocaleString('de-DE', { maximumFractionDigits: 0 }); }
  function dec(n, d) { return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }); }
  function totalLen(n) { return SEG_PITCH * n + FIXED; }

  /* Spread segments as evenly as possible across systems, longest run first.
     ceil() guarantees no run exceeds perRun, so every run still fits. */
  function splitRuns(segments, systems) {
    var base = Math.floor(segments / systems), rem = segments % systems, out = [];
    for (var i = 0; i < systems; i++) { out.push(base + (i < rem ? 1 : 0)); }
    return out;
  }

  /* A plain join reads fine for a few runs; past that it becomes a wall, so
     collapse to counts: 18 x 6, or 17 x 5 + 1 x 4 when the runs differ. */
  function describeRuns(runList) {
    if (runList.length <= 6) { return runList.join(' + '); }
    var counts = {};
    runList.forEach(function (r) { counts[r] = (counts[r] || 0) + 1; });
    return Object.keys(counts)
      .sort(function (a, b) { return b - a; })
      .map(function (k) { return counts[k] + ' × ' + k; })
      .join(' + ');
  }

  function init(root) {
    if (root.getAttribute('data-nbx-ready')) { return; }
    root.setAttribute('data-nbx-ready', '1');

    function el(name) { return root.querySelector('[data-el=' + name + ']'); }

    /* Theme settings win over the built-in defaults where provided. */
    var threshold = parseInt(root.getAttribute('data-handoff'), 10);
    if (isNaN(threshold) || threshold < 1) { threshold = HANDOFF_SEGMENTS; }
    var copy = {
      handoffTitle: root.getAttribute('data-handoff-title') || COPY.handoffTitle,
      handoffBody: root.getAttribute('data-handoff-body') || COPY.handoffBody
    };

    var str = {}, k;
    for (k in STR) { if (Object.prototype.hasOwnProperty.call(STR, k)) { str[k] = STR[k]; } }
    var i18nEl = root.querySelector('[data-el=i18n]');
    if (i18nEl) {
      try {
        var loaded = JSON.parse(i18nEl.textContent);
        for (k in loaded) {
          if (Object.prototype.hasOwnProperty.call(loaded, k) && loaded[k]) { str[k] = decode(loaded[k]); }
        }
      } catch (e) { /* keep the English fallbacks */ }
    }
    function t(key, vars) { return vars ? fill(str[key], vars) : str[key]; }

    /* Plural nouns follow the page language's rules (Croatian has one/few/other),
       falling back to 'other', then to the English pair. */
    var lang = document.documentElement.lang || 'en';
    var plural;
    try { plural = new Intl.PluralRules(lang); } catch (e) { plural = null; }
    function word(base, n) {
      var form = plural ? plural.select(n) : (n === 1 ? 'one' : 'other');
      return str[base + '_' + form] || str[base + '_other'] || STR[base + '_other'];
    }

    var hens = el('hens'), range = el('range'), coop = el('coop'), customRate = el('customRate');
    var stds = root.querySelectorAll('[data-el=std]');

    function rate() {
      var picked = root.querySelector('[data-el=std]:checked');
      var v = picked ? picked.value : 'organic';
      if (v === 'conv') { return 120; }
      if (v === 'custom') { return Math.max(10, Math.min(200, parseFloat(customRate.value) || 70)); }
      return 10000 / 120;
    }

    function svg(tag, attrs, text) {
      var node = document.createElementNS('http://www.w3.org/2000/svg', tag);
      for (var k in attrs) {
        if (Object.prototype.hasOwnProperty.call(attrs, k)) { node.setAttribute(k, attrs[k]); }
      }
      if (text !== undefined) { node.textContent = text; }
      return node;
    }

    /* Draws every system, one run per row, all on one shared scale so the runs
       are directly comparable. Bands top to bottom:
         3..20    coop-limit label, alone in its own band
         34..     one row per system, each index INSIDE its own box
         below    dimension line for the longest run, then any overflow note */
    function diagram(runList, limit) {
      var W = 1000, padR = 46, MAX_DRAWN = 8;
      var multi = runList.length > 1;
      var padL = multi ? 96 : 46;
      var draw = W - padL - padR;
      var drawn = runList.slice(0, MAX_DRAWN);
      var hidden = runList.length - drawn.length;
      var longest = Math.max.apply(null, runList);
      var longestLen = totalLen(longest);
      var s = draw / Math.max(longestLen, limit || 0);
      var aW = FIXED * s, sW = SEG_PITCH * s;
      var rowsTop = 34, boxH = 46, rowH = 62;
      var lastBottom = rowsTop + (drawn.length - 1) * rowH + boxH;
      var dimY = lastBottom + 24;
      var H = dimY + (hidden > 0 ? 34 : 16);

      var g = svg('svg', {
        viewBox: '0 0 ' + W + ' ' + H,
        role: 'img',
        'aria-label': runList.length === 1
          ? t('diagram_aria_single', { segments: longest, length: longestLen })
          : t('diagram_aria_multi', { systems: runList.length, segments: longest, length: longestLen })
      });

      var defs = svg('defs');
      var pat = svg('pattern', {
        id: 'nbxHatch', width: 7, height: 7,
        patternTransform: 'rotate(45)', patternUnits: 'userSpaceOnUse'
      });
      pat.appendChild(svg('rect', { width: 7, height: 7, 'class': 'sv-hatch-bg' }));
      pat.appendChild(svg('line', { x1: 0, y1: 0, x2: 0, y2: 7, 'class': 'sv-hatch-line' }));
      defs.appendChild(pat);
      g.appendChild(defs);

      for (var row = 0; row < drawn.length; row++) {
        var segs = drawn[row], yBox = rowsTop + row * rowH;

        if (multi) {
          g.appendChild(svg('text', {
            'class': 'sv-idx', x: padL - 14, y: yBox + boxH / 2 + 4, 'text-anchor': 'end'
          }, t('diagram_row', { number: row + 1 })));
        }

        g.appendChild(svg('rect', { 'class': 'sv-allow', x: padL, y: yBox, width: aW.toFixed(1), height: boxH }));
        if (aW > 52) {
          g.appendChild(svg('text', {
            'class': 'sv-idx', x: (padL + aW / 2).toFixed(1), y: yBox + boxH / 2 + 4, 'text-anchor': 'middle'
          }, '575'));
        }

        for (var i = 0; i < segs; i++) {
          var x = padL + aW + i * sW;
          g.appendChild(svg('rect', { 'class': 'sv-seg', x: x.toFixed(1), y: yBox, width: sW.toFixed(1), height: boxH }));
          if (sW > 26) {
            /* Index sits top-left inside its box, well clear of the centred label
               and of a limit line, which most often falls mid-box. */
            g.appendChild(svg('text', {
              'class': 'sv-idx', x: (x + 7).toFixed(1), y: yBox + 15, 'text-anchor': 'start'
            }, String(i + 1)));
          }
          if (sW > 54) {
            g.appendChild(svg('text', {
              'class': 'sv-seg-t', x: (x + sW / 2).toFixed(1), y: yBox + 34, 'text-anchor': 'middle'
            }, '1 m²'));
          }
        }
      }

      var xEnd = padL + longestLen * s;
      g.appendChild(svg('path', { 'class': 'sv-dim', d: 'M' + padL + ' ' + (lastBottom + 6) + ' V' + (dimY + 9) }));
      g.appendChild(svg('path', { 'class': 'sv-dim', d: 'M' + xEnd.toFixed(1) + ' ' + (lastBottom + 6) + ' V' + (dimY + 9) }));
      g.appendChild(svg('path', { 'class': 'sv-dim', d: 'M' + padL + ' ' + dimY + ' H' + xEnd.toFixed(1) }));
      g.appendChild(svg('path', { 'class': 'sv-arrow', d: 'M' + (padL + 1) + ' ' + dimY + ' l10 -4 v8 z' }));
      g.appendChild(svg('path', { 'class': 'sv-arrow', d: 'M' + (xEnd - 1).toFixed(1) + ' ' + dimY + ' l-10 -4 v8 z' }));

      var mid = (padL + xEnd) / 2;
      g.appendChild(svg('rect', { 'class': 'sv-plate', x: mid - 52, y: dimY - 11, width: 104, height: 22 }));
      g.appendChild(svg('text', { 'class': 'sv-dim-t', x: mid, y: dimY + 5, 'text-anchor': 'middle' }, grp(longestLen) + ' mm'));

      if (hidden > 0) {
        g.appendChild(svg('text', {
          'class': 'sv-idx', x: padL, y: dimY + 28, 'text-anchor': 'start'
        }, t('diagram_more', { count: hidden, systemWord: word('system', hidden) })));
      }

      if (limit > 0) {
        var xL = padL + limit * s;
        var limPath = 'M' + xL.toFixed(1) + ' 26 V' + (lastBottom + 10);
        /* Line stops short of the label band, so the two never touch. A halo
           in the section background keeps it legible over a box or a digit. */
        g.appendChild(svg('path', { d: limPath, 'class': 'sv-lim-halo' }));
        g.appendChild(svg('path', { 'class': 'sv-lim', d: limPath }));
        var label = t('diagram_coop_limit', { length: grp(limit) });
        var atEnd = xL > padL + draw - 150;
        g.appendChild(svg('text', {
          'class': 'sv-lim-t', x: (atEnd ? xL - 8 : xL + 8).toFixed(1), y: 17, 'text-anchor': atEnd ? 'end' : 'start'
        }, label));
      }

      var host = el('dia');
      host.textContent = '';
      host.appendChild(g);
    }

    function flag(cls, title, body) {
      var wrap = document.createElement('div');
      wrap.className = 'flag is-' + cls;
      var dot = document.createElement('span');
      dot.className = 'flag-dot';
      var box = document.createElement('div');
      var b = document.createElement('b');
      b.textContent = title;
      box.appendChild(b);
      if (body) {
        var p = document.createElement('p');
        p.textContent = body;
        box.appendChild(p);
      }
      wrap.appendChild(dot);
      wrap.appendChild(box);
      return wrap;
    }

    function stat(target, main, note) {
      target.textContent = main;
      if (note) {
        var em = document.createElement('em');
        em.textContent = ' ' + note;
        target.appendChild(em);
      }
    }

    function render() {
      var h = Math.max(1, Math.min(MAX_HENS, Math.round(parseFloat(hens.value) || 1)));
      var r = rate();
      var need = h / r;
      var n = Math.max(1, Math.ceil(need));
      var limit = Math.max(0, Math.round(parseFloat(coop.value) || 0));
      var capacity = Math.floor(n * r);
      var achieved = h / (n * SEG_AREA);
      var spare = capacity - h;

      /* How many segments one run can carry: the coop's fit, capped by the
         longest run we publish. With no coop given, only the cap applies. */
      var coopFit = limit > 0 ? Math.floor((limit - FIXED) / SEG_PITCH) : Infinity;
      var perRun = Math.min(MAX_PER_RUN, coopFit);
      var tooShort = perRun < 1;
      var systems = tooShort ? 0 : Math.ceil(n / perRun);
      var runs = tooShort ? [] : splitRuns(n, systems);
      var runSeg = tooShort ? 1 : runs[0];
      var runLen = totalLen(runSeg);
      var handoff = !tooShort && n > threshold;

      el('segCount').textContent = n;
      var segWordEl = el('segWord');
      segWordEl.textContent = word('segment', n);
      var small = document.createElement('small');
      small.textContent = t('segment_size_note');
      segWordEl.appendChild(small);

      el('sysCount').textContent = tooShort ? '—' : systems;
      var sysWord = el('sysWord');
      sysWord.textContent = word('system', tooShort ? 1 : systems);
      var sysSmall = document.createElement('small');
      sysSmall.textContent = tooShort
        ? t('coop_too_short')
        : (systems > 1 ? t('runs_split', { runs: describeRuns(runs) }) : t('one_run_of', { count: n }));
      sysWord.appendChild(sysSmall);

      stat(el('area'), dec(n * SEG_AREA, 2) + ' m²', t('area_need', { value: dec(need, 2) }));
      stat(el('len'), grp(runLen) + ' mm', systems > 1 ? t('length_per_system') : dec(runLen / 1000, 2) + ' m');
      stat(el('dens'), dec(achieved, 1) + ' ' + t('hens_per_m2'), t('density_max', { value: dec(r, 1) }));
      stat(el('cap'), t('capacity_value', { count: grp(capacity) }),
        (spare >= 0 ? t('capacity_spare', { count: grp(spare) }) : grp(spare)));

      el('diaScale').textContent = tooShort
        ? ''
        : (systems > 1
          ? t('scale_multi', { systems: systems, systemWord: word('system', systems), length: grp(runLen) })
          : t('scale_single', { length: grp(runLen) }));

      /* Soft handoff: the fixed lead time is the one claim that stops being
         true at scale, so swap only that. Every figure stays put. */
      if (el('ctaNormal') && el('ctaScale')) {
        el('ctaNormal').hidden = handoff;
        el('ctaScale').hidden = !handoff;
      }

      var flags = el('flags');
      flags.textContent = '';

      if (tooShort) {
        flags.appendChild(flag('bad',
          t('too_short_title'),
          t('too_short_body', { needed: grp(totalLen(1)), available: grp(limit) })));
      } else {
        if (handoff) {
          flags.appendChild(flag('tip',
            fill(copy.handoffTitle, { threshold: threshold }),
            fill(copy.handoffBody, {
              segments: n,
              systems: systems,
              systemWord: word('system', systems)
            })));
        }

        /* Only worth saying when the flock is near what the minimum actually
           holds. Trigger: under half a segment of spare nest space left.
           Crowded nests are a main cause of floor eggs, so add one per run. */
        if (spare < r / 2) {
          var recSeg = n + systems;
          var recSystems = Math.ceil(recSeg / perRun);
          var recRuns = splitRuns(recSeg, recSystems);
          flags.appendChild(flag('tip',
            t('recommend_title', { segments: recSeg, segmentWord: word('segment', recSeg) }),
            t('recommend_body', { hens: grp(h), spare: Math.floor(spare) }) + ' ' +
            (recSystems > systems
              ? t('recommend_more_systems', { perRun: perRun, systems: recSystems, runs: describeRuns(recRuns) })
              : t('recommend_same_systems', {
                  runs: describeRuns(recRuns),
                  systems: recSystems,
                  systemWord: word('system', recSystems),
                  capacity: grp(Math.floor(recSeg * r))
                }))));
        }

        if (systems > 1 && !handoff) {
          flags.appendChild(flag('warn',
            t('split_title', { systems: systems, runs: describeRuns(runs) }),
            coopFit <= MAX_PER_RUN
              ? t('split_body_coop', {
                  coop: grp(limit), perRun: perRun, segmentWord: word('segment', perRun),
                  systems: systems, length: grp(runLen)
                })
              : t('split_body_cap', { max: MAX_PER_RUN, systems: systems, length: grp(runLen) })));
        }
        if (limit > 0 && systems === 1) {
          flags.appendChild(flag('ok',
            t('fits_title', { spare: grp(limit - runLen) }),
            t('fits_body', {
              coop: grp(limit), perRun: perRun, segmentWord: word('segment', perRun),
              capacity: grp(Math.floor(perRun * r))
            })));
        }
      }

      diagram(tooShort ? [1] : runs, limit);
    }

    /* Always pin the slider inside its own bounds rather than leaving it
       stranded at its last position when the typed value runs past it. */
    function syncSlider() {
      var v = parseFloat(hens.value);
      if (!isNaN(v)) {
        range.value = Math.max(parseFloat(range.min), Math.min(parseFloat(range.max), v));
      }
    }
    hens.addEventListener('input', function () { syncSlider(); render(); });
    /* On commit, show the clamped figure so the field can never disagree
       with the results below it. */
    hens.addEventListener('change', function () {
      var v = Math.round(parseFloat(hens.value));
      if (isNaN(v)) { v = 1; }
      hens.value = Math.max(1, Math.min(MAX_HENS, v));
      syncSlider();
      render();
    });
    range.addEventListener('input', function () { hens.value = range.value; render(); });
    coop.addEventListener('input', render);
    customRate.addEventListener('input', function () {
      var c = root.querySelector('[data-el=std][value=custom]');
      if (c) { c.checked = true; }
      render();
    });
    Array.prototype.forEach.call(stds, function (s) { s.addEventListener('change', render); });

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.nbx-calc'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
